<template>
	<v-row>
		<v-row justify="center" class="pt-5">
			<v-col md="11" xl="7" class="pt-0">
				<div v-if="this.$route.params.catalogo">
					<div v-if="this.loading">
						<v-row justify="center">
							<v-progress-circular indeterminate color="primary" />
						</v-row>
					</div>
					<div v-else>
						<div v-if="this.catalogo">
							<div v-if="!this.statusCatalogo.expirado">
								<div v-if="this.statusCatalogo.horaFuncionamento">
									<div v-if="this.statusCatalogo.aberto">
										<v-row justify="center" class="text" v-if="this.empresa.obsTelaInicial">
											<div class="tela-inicial__observacao">
												{{ this.empresa.obsTelaInicial }}
											</div>
										</v-row>
										<v-row><Content /></v-row>
									</div>
									<div v-else>
										<v-row justify="center" class="texto--text">
											<p style="font-size: 19px; font-weight: bold">
												{{
													`O horário de funcionamento para pedidos é das ${horaAbertura} até às ${horaFechamento}`
												}}
											</p>
										</v-row>
									</div>
								</div>
								<div v-else>
									<v-row><Content /></v-row>
								</div>
							</div>
							<div v-else>
								<v-row justify="center">
									<p style="font-size: 19px; font-weight: bold" class="texto-expirado">O catalogo expirou!</p>
								</v-row>
							</div>
						</div>
						<div v-else>
							<v-row justify="center">
								<p style="font-size: 19px; font-weight: bold">Nenhum catálogo encontrado!</p>
							</v-row>
						</div>
					</div>
				</div>
				<div v-else>
					<v-row justify="center">
						<p style="font-size: 19px; font-weight: bold">Nenhum catálogo encontrado!</p>
					</v-row>
				</div>
			</v-col>
		</v-row>
	</v-row>
</template>

<script>
import Content from '../components/Home/Content'
import { mapGetters, mapActions } from 'vuex'

export default {
	title: 'Foo Page',
	name: 'Home',
	components: { Content },
	data: function () {
		return {
			loading: false,
			identificador: {},
			itens: {},
			marcas: {},
			subgrupos: {},
			skus: {},
			content: {},
		}
	},
	async mounted() {
		if (JSON.stringify(this.itensCarregados) === '{}') await this.load()
	},
	methods: {
		...mapActions(['addItens', 'addMarcas', 'addGrupos', 'addSubgrupos', 'addTotal', 'delToCart', 'addToCart', 'addSkus']),
		async load() {
			try {
				if (!this.statusCatalogo.expirado) {
					if (
						(this.statusCatalogo.horaFuncionamento && this.statusCatalogo.aberto) ||
						!this.statusCatalogo.horaFuncionamento
					) {
						const marca = this.$route.query.marca ? this.$route.query.marca : ''
						const pagina = this.$route.query.pagina ? this.$route.query.pagina : 1
						const search = this.$route.query.search ? this.$route.query.search : ''
						const grupo = this.$route.query.grupo ? this.$route.query.grupo : ''
						const subgrupo = this.$route.query.subgrupo ? this.$route.query.subgrupo : ''
						const cor = this.$route.query.cor ? this.$route.query.cor : ''
						const tamanho = this.$route.query.tamanho ? this.$route.query.tamanho : ''
						const voltagem = this.$route.query.voltagem ? this.$route.query.voltagem : ''
						const sabor = this.$route.query.sabor ? this.$route.query.sabor : ''

						this.loading = true
						this.itens = await this.axios.get(
							`/catalogos/${this.catalogo.id}/itens?search=${search}&marca=${marca}&grupo=${grupo}&subgrupo=${subgrupo}&cor=${cor}&tamanho=${tamanho}&voltagem=${voltagem}&sabor=${sabor}&page=${pagina}&limit=12`
						)
						this.marcas = await this.axios.get(`/catalogos/${this.catalogo.id}/marcas`)
						this.grupos = await this.axios.get(`/catalogos/${this.catalogo.id}/grupos`)
						this.subgrupos = await this.axios.get(`/catalogos/${this.catalogo.id}/subgrupos`)
						this.skus = await this.axios.get(`/catalogos/${this.catalogo.id}/skus`)

						this.addItens(this.itens.data.itens)
						this.addMarcas(this.marcas.data)
						this.addGrupos(this.grupos.data)
						this.addSubgrupos(this.subgrupos.data)
						this.addSkus(this.skus.data)
						this.addTotal(this.itens.data.total)
					}
				}
			} catch (error) {
				// this.$store.dispatch('showError', 'Nenhum ID informado')
			} finally {
				this.loading = false
			}
		},
	},
	computed: {
		...mapGetters({
			catalogo: 'catalogo',
			empresa: 'empresa',
			statusCatalogo: 'statusCatalogo',
			itensCarregados: 'itens',
			cartProducts: 'cartProducts',
		}),
		horaAbertura() {
			var data = new Date(this.catalogo.hora_abertura)
			return this.convertTime2(data)
		},
		horaFechamento() {
			var data = new Date(this.catalogo.hora_fechamento)
			return this.convertTime2(data)
		},
	},
	watch: {
		'$route.query'() {
			this.load()
		},
	},
}
</script>

<style scoped>
.tela-inicial__observacao {
	width: 100%;
	background: var(--v-primary-base);
	border-radius: 13px;
	color: var(--v-textoBotoes-base);
	font-weight: bold;
	text-align: center;
	padding: 1rem;
	margin-bottom: 1rem;
}

.texto-expirado{
	color: var(--v-texto-base);
}
</style>